import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { TranslateModule } from '@ngx-translate/core';
import { RestrictedAccessPageComponent } from '@pages/shared/restricted-access';
import { UiNgLetModule } from '@uipath/angular/directives/ui-ng-let';

@NgModule({
    imports: [
        CommonModule,
        MatCardModule,
        TranslateModule,
        UiNgLetModule,
    ],
    declarations: [
        RestrictedAccessPageComponent,
    ],
    exports: [
        RestrictedAccessPageComponent,
    ],
})
export class SharedPageModule { }
